
<template>
    <van-pull-refresh v-model="loading" @refresh="loadData">
      <van-skeleton title :row="6" :loading="loading">
        <div>
          <van-cell-group v-for="group in form" :title="group.name" :key="group.name.hash" class="van-cell-group2">
            <div v-for="item in group.itemList" :key="item.id">
              <SysPicker v-if="item.type === 'picker'" @onConfirm="(options,index) => {updateData(item.id,options.value)}"
                         :title="item.title"
                         :value="(item.value)"
                         :label="item.label"
                         :columns="item.options"
                         :showDivider="true"
                />
              <SysSwitch v-else-if="item.type === 'switch'" :showDivider="true" :title="item.title" :label="item.label" :checked="item.value" @change="(value) => {updateData(item.id,value)}"/>
              <SysCell v-else-if="item.type === 'cell'" :showDivider="true" :title="item.title" :label="item.label"  :isLink="true" :to="{name:item.to,params:{...item.value,id:item.id,label:item.label,title:item.title}}" :value="item.value?item.value.text:null" />
            </div>

          </van-cell-group>
        </div>
      </van-skeleton>
      <fast-order-index>

      </fast-order-index>
    </van-pull-refresh>
</template>

<script>
import {Collapse, CollapseItem, Button,Notify,Cell, CellGroup,Form ,Field,Switch
  ,Col,Row,Picker,Popup,Divider,Skeleton,PullRefresh} from 'vant';
import SysPicker from "@/view/setting/component/SysPicker";
import SysSwitch from "@/view/setting/component/SysSwitch";
import SysCheckbox from "@/view/setting/component/SysCheckbox";
import SysCell from "@/view/setting/component/SysCell";
import FastOrder from "@/view/order/fast_index";
import {setToken} from "@/util/auth";
import {getImei, setSaasId, setImei} from "@/util/session-storage-utils";
import {getSetting,updateSetting} from "@/api/devicesetting"
import FastOrderIndex from "@/view/order/fast_index";
export default {
  components: {
    FastOrderIndex,
    [SysPicker.name]:SysPicker,
    [SysSwitch.name]:SysSwitch,
    [SysCheckbox.name]:SysCheckbox,
    [SysCell.name]:SysCell,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Switch.name]: Switch,
    [Col.name]: Col,
    [Row.name]: Row,
    [Picker .name]: Picker,
    [Popup .name]: Popup,
    [Divider .name]: Divider,
    [Skeleton .name]: Skeleton,
    [PullRefresh .name]: PullRefresh,
    [Button.name]: Button,
    [FastOrder.name]: FastOrder
  },
  props:{
    token:String
  },
  name: "device-setting",
  data() {
    return {
      loading:true,
      form:[],
      activeNames:[1],
      checked:false,
      showPicker:false
    }
  },
  methods:{
    updateData(field,value){
      let req = {};
      req[field] = value;
      updateSetting(getImei(),req).then(
          (res) => {
            if(res.code == 0){
              Notify({ type: 'success', message: '数据更新成功',duration:500 })
            }

      }
      )
    },
    loadData(){
      let imei = getImei();
      getSetting(imei).then((res) => {
        this.loading = false
        this.form = res.data;
      })
    }

  },
  created(){
    setToken(this.$route.query._token)
    let imei = this.$route.query._imei;
    setImei(imei)
    let saasId = this.$route.query._saasId;
    setSaasId(saasId)
    this.loadData();
  },
  activated() {
    this.loadData();
  }
}
</script>

<style scoped>
</style>
